import { render } from "./FeynmanForm.vue?vue&type=template&id=56a6759e&scoped=true"
import script from "./FeynmanForm.vue?vue&type=script&lang=js"
export * from "./FeynmanForm.vue?vue&type=script&lang=js"

import "./FeynmanForm.vue?vue&type=style&index=0&id=56a6759e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a6759e"]])

export default __exports__